// @flow
import React from 'react';
import {useIntl, defineMessages} from 'react-intl';

import Select, {SelectOption} from 'sail/Select';
import {lookUpResourceByName} from './resources';
import {useApiExplorer} from './ApiExplorerProvider';
import type {Commands} from '../StripeClui/helpers/commands/resource';

type ActionSelectorProps = {|
  resources: Commands,
|};

const messages = defineMessages({
  selectAction: {
    id: 'docsApp.actionSelector.selectAction',
    description: 'Placeholder text for action selector',
    defaultMessage: 'Select an action',
  },
});

export const ActionSelector = ({resources}: ActionSelectorProps) => {
  const intl = useIntl();
  const {
    state: {resource, action},
    setAction,
  } = useApiExplorer();

  const resourceCommand = lookUpResourceByName(resources, resource);
  const options = [
    <SelectOption
      key="placeholder"
      value=""
      label={intl.formatMessage(messages.selectAction)}
      disabled
    />,
    resourceCommand &&
      Object.keys(resourceCommand).map((item) => (
        <SelectOption key={item} value={item} label={item} />
      )),
  ].filter(Boolean);

  return (
    <Select
      required
      value={action}
      onChange={setAction}
      width={240}
      disabled={resource === ''}
      size="jumbo"
    >
      {options}
    </Select>
  );
};
